/**
 * Popup actions.
 * @module actions/popup/popup
 */

import { searchContent } from '@plone/volto/actions/search/search';

/**
 * Get popups action.
 * @function getPopups
 * @param {Object} options Search options.
 * @returns {Object} Get popups action.
 */
export function getPopups(options = {}) {
  const searchOptions = {
    portal_type: 'popup',
    active: true,
    sort_on: 'priority',
    sort_order: 'descending',
    fullobjects: true,
    ...options,
  };

  return searchContent('', searchOptions, 'popups');
}
